import React from 'react';
import { makeStyles } from '@mui/styles';
import SuitPattern from '../../Components/SuitPattern.js';
import HighlightSection from '../../Components/Sales/HighlightSection.js';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    height: '74rem',
    overflow: 'hidden',
    backgroundColor: '#f7f7f7',
    // makes the green BG on the text container extend
    // to the right edge of the viewport
    '&:after': {
      content: '" "',
      position: 'absolute',
      right: 0,
      left: 'calc(50% + 59rem)',
      top: 0,
      bottom: 0,
      backgroundColor: '#0e765f'
    },
    [theme.breakpoints.down('md')]: {
      height: '56rem',
      '&:after': {
        content: 'none'
      }
    }
  },
  contentContainer: {
    maxWidth: '118rem',
    margin: '0 auto',
    zIndex: 1,
    height: '100%',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  image: {
    backgroundImage: 'url(img/components/sales/couple1.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center top',
    height: '100%',
    position: 'absolute',
    width: 1000,
    right: '40%',
    // this allows us to fade out the left-hand side of the image
    // so there's no clean edge
    maskImage: 'linear-gradient(to right, transparent 0%, rgba(0, 0, 0, 1) 15%)',
    [theme.breakpoints.down('lg')]: {
      right: '25%'
    },
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      right: 0,
      width: '100%',
      height: '50%',
      maskImage: 'none'
    }
  },
  textContainer: {
    position: 'absolute',
    right: 0,
    left: '60%',
    height: '100%',
    display: 'flex',
    padding: '5rem 1rem 5rem 5rem',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: '#0e765f',
    // slight shadow fade at the left edge of the copy section
    '&:before': {
      content: '" "',
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      width: 15,
      backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0))'
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '50%',
      left: 0,
      position: 'relative',
      padding: '4rem 2rem',
      '&:before': {
        content: 'none'
      }
    }
  },
  suitPattern: {
    right: -300,
    left: 'auto',
    zIndex: 1,
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  }
}));

const Highlight1 = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <div className={classes.image} />
        <SuitPattern
          opacity={0.07}
          className={classes.suitPattern}
        />
        <div className={classes.textContainer}>
          <HighlightSection
            heading={t('if-you-arent-laughing')}
            body={t('we-have-the-most-engaging-bridge-teachers')}
          />
        </div>
      </div>
    </div>
  );
};

export default Highlight1;
